import React from "react";
import { useAuthUserContext } from "../../context/UserContext";
import { Redirect } from "react-router-dom";

import styles from "./LogoutPage.module.css";
import PageHeader from "../App/PageHeader";
import DarkPage from "../UserInterfaceElements/DarkPage";
import useManifesto from "../../hooks/useManifesto";

const LogoutPage: React.FC = () => {
  const { error, logout, loggedIn } = useAuthUserContext();

  const {reload} = useManifesto('0');

  const doLogout = async () => {
    try {
      reload();
      logout();
    } catch (ex) {
      console.error(ex);
    }
  };

  if (!loggedIn) {
    return <Redirect to="/login" />;
  }

  return (<DarkPage>
    <div className={styles.LogoutPage}>
      <PageHeader>Logout</PageHeader>
      {error && <p>{error}</p>}
      <button onClick={doLogout}>Logout</button>
    </div></DarkPage>
  );
};

export default LogoutPage;
